import { useParams } from "react-router-dom";
import { separate } from "../PaymentHistory";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { GatewayList, Get_Subject_Payment, Payment_new, get_media } from "../../api/api";
import { removeHTML_tags } from "../loops/itemsType";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

const validateEmail = (email) => {
      return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};


const gateWayArr = ['زرین پال', 'نکست پی', 'آی دی پی']
const disabledStyle = { pointerEvents: 'none', touchAction: 'none', backgroundColor: '#cdcdcd' }
const parse = require('html-react-parser')

const Shop = () => {

      const [loading, setLoading] = useState(false)
      const [content, setContent] = useState([])
      const [phoneNumber, setPhoneNumber] = useState('')
      const [email, setEmail] = useState('')
      const [disabled, setDisabled] = useState(true)
      const [gatewaylist, setGetwaylist] = useState([])
      const [gatewayChecked, setGetwayChecked] = useState(1)

      const InputRef = useRef(null)

      const params = useParams()


      const onChangeInputNumber = event => {
            if (event.target.value.length === 1 && event.target.value !== '0') {
                  event.target.value = 0 + event.target.value
            }

            event.target.value = event.target.value
                  .replace(/[^0-9.]/g, '')
                  .replace(/(\..*)\./g, '$1')

            setPhoneNumber(event.target.value)

            if (event.target.value.length === 11) {
                  setDisabled(false)
            } else {
                  setDisabled(true)
            }
      }



      useEffect(() => {
            const getContent = async () => {
                  try {
                        setLoading(true)
                        const res = await axios.get(Get_Subject_Payment(params.subjectId, params.branchId, params.publisherId))
                        setContent(res.data)

                        const GateWays_ = await axios.get(GatewayList)
                        setGetwaylist(GateWays_.data);
                  } finally {
                        setLoading(false)
                  }
            }
            getContent()
      }, [])



      const formSumbit = async (e) => {
            e.preventDefault()

            // const phoneNumberRegex = /09(1[0-9]|3[1-9]|2[1-9])-?[0-9]{3}-?[0-9]{4}/gm
            // if (!phoneNumberRegex.test(phoneNumber)) return toast.error('شماره موبایل صحیح نمیباشد.')
            if (email && !validateEmail(email)) return toast.error('ایمیل صحیح نمیباشد.')

            const formData = new FormData()
            formData.append("subjectBranchId", parseInt(params.branchId))
            formData.append("PublisherId", parseInt(params.publisherId))
            formData.append("phoneNumber", phoneNumber)
            formData.append("email", email)
            formData.append("gateWayType", parseInt(gatewayChecked))

            try {
                  setLoading(true)
                  const res = await axios.post(Payment_new, formData)
                  if (res.data?.redirectLink) window.location.href = res.data.redirectLink
            } catch (error) {
                  const err = error.response?.data?.errors
                  if (err) {
                        const errorItems = Object.values(err)
                        errorItems.map(item => item.map(text => toast.error(text)))
                  }
                  setLoading(false)
            }
      }



      return (
            <>
                  <Helmet>
                        <title>{content.paymentTitle}</title>
                        <meta name='description' content={`${content.paymentTitle} - ${removeHTML_tags(content.description)}`} />
                  </Helmet>
                  <div className="container">
                        <div className="shop">

                              {content.paymentTitle && <h1>{content.paymentTitle}</h1>}

                              <div className="row flexDi">


                                    <div className="col-lg-9 col-md-12">

                                          <form onSubmit={formSumbit}>
                                                <div className="emailPhone">

                                                      <input
                                                            ref={InputRef}
                                                            onChange={onChangeInputNumber}
                                                            type='text'
                                                            name='phoneNumber'
                                                            className='justnumber'
                                                            placeholder='شماره موبایل'
                                                            maxLength='11'
                                                            style={{ direction: phoneNumber.length > 0 ? 'ltr' : 'rtl' }}
                                                      />

                                                      <input style={{ direction: email.length > 0 ? 'ltr' : 'rtl' }} name='email' type="email" placeholder="ایمیل (اختیاری)" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                      <p>جهت خرید و دریافت لینک دانلود <span>ایمیل معتبر و شماره موبایل</span> خود را وارد کنید.</p>
                                                </div>

                                                <div className="payment">
                                                      <h4>درگاه پرداخت</h4>
                                                      <div className="paymentRole">
                                                            {gatewaylist.map(i => {
                                                                  if (gateWayArr.includes(i.title)) {
                                                                        if (i.title === 'زرین پال') return (
                                                                              <label htmlFor="zarin_pal" key={i.id}>
                                                                                    <input type="radio" name="a" id="zarin_pal" defaultChecked onClick={() => setGetwayChecked(i.id)} />
                                                                                    <span><img src="/assets/images/zarin_pal.png" alt="zarin_pal" />{i.title}</span>

                                                                              </label>
                                                                        )
                                                                        if (i.title === 'آی دی پی') return (
                                                                              <label htmlFor="id_pay" key={i.id}>
                                                                                    <input type="radio" name="a" id="id_pay" onClick={() => setGetwayChecked(i.id)} />
                                                                                    <span><img src="/assets/images/id_pay.png" alt="id_pay" />{i.title}</span>
                                                                              </label>
                                                                        )
                                                                  } else {
                                                                        return (
                                                                              <label htmlFor={i.id} key={i.id}>
                                                                                    <input type="radio" name="a" id={i.id} onClick={() => setGetwayChecked(i.id)} />
                                                                                    <span>{i.title}</span>
                                                                              </label>
                                                                        )
                                                                  }

                                                            })}
                                                            {/*  <label htmlFor="id_pay">
                                                                  <input type="radio" name="a" id="id_pay" defaultChecked />
                                                                  <span><img src="/assets/images/id_pay.png" alt="id_pay" /></span>
                                                            </label>
                                                            <label htmlFor="next_pay">
                                                                  <input type="radio" name="a" id="next_pay" />
                                                                  <span><img src="/assets/images/next_pay.png" alt="next_pay" /></span>
                                                            </label>
                                                            <label htmlFor="zarin_pal">
                                                                  <input type="radio" name="a" id="zarin_pal" />
                                                                  <span><img src="/assets/images/zarin_pal.png" alt="zarin_pal" /></span>
                                                            </label> */}
                                                      </div>
                                                </div>

                                                <button
                                                      style={disabled ? disabledStyle : {}}
                                                      className={'submit'} disabled={loading}>{loading ? 'لطفا صبر کنید...' : 'خرید و دانلود'}</button>
                                          </form>



                                          <div className="details">
                                                <ul>
                                                      {content.branchTitle && <li>نسخه : {content.branchTitle}</li>}
                                                      {content.size && <li>حجم : <span>{content.size} مگابایت</span></li>}
                                                      {content.price && <li>قیمت : <span>{separate(content.price)} ریال</span></li>}
                                                </ul>
                                          </div>


                                          <p className="note success">هنگام پرداخت، 9 درصد مالیات بر ارزش افزوده به قیمت فوق افزوده میشود.</p>
                                          <p className="note warning">ترافیک مصرفی برای تمام اپراتورهای اینترنت به صورت نیم بها محاسبه خواهد شد.</p>

                                          <h2 className="title">همکاری در فروش</h2>

                                          <div className="box">
                                                <h5>پشتیبانی</h5>
                                                <p>در صورت نیاز از طریق یکی از روش های زیر با پشتیبانی تماس بگیرید</p>
                                                <p>1. ارسال ایمیل به آدرس sekaanscom@gmail.com</p>
                                                <p>2. ارسال پیام به آدرس تلگرام STM_WEB</p>
                                                <p>ارسال پیام به واتس آپ یا تلگرام به شماره زیر :</p>
                                                <p>09939207262</p>
                                          </div>

                                          {content.paymentDescription && <div className="box">
                                                <h5>توضیحات بیشتر</h5>
                                                {parse(content.paymentDescription)}
                                                {/* <p>در صورت نیاز از طریق یکی از روش های زیر با پشتیبانی تماس بگیرید</p>
                                                <p>1. ارسال ایمیل به آدرس support@sekaans.con</p>
                                                <p>2. ارسال پیام به آدرس تلگرام Support_Sekaans</p>
                                                <p>ارسال پیام به واتس آپ یا تلگرام به شماره زیر :</p>
                                                <p>09357896697</p> */}
                                          </div>}

                                          <div className="box">
                                                <h5>راهنمای دانلود</h5>
                                                <p>در گوشی های اندروید از برنامه adm جهت دانلود استفاده نمایید (پلی استور).</p>
                                                <p>در سیستم عامل IOS از برنامه Documents جهت دانلود استفاده نمایید (اپ استور).</p>
                                                <p>در کامپیوتر از نرم افزار Flash Get یا idm جهت دانلود استفاده نمایید.</p>
                                          </div>



                                    </div>


                                    <div className="col-lg-3 col-md-12">
                                          <div className="sidebarShoping">
                                                <img style={{ margin: '0 auto', display: 'block' }} src={get_media(content.posterId)} alt={content.title} />

                                                <h3>{content.title}</h3>

                                                <hr />
                                                {content.description && <p className="ellipsis-4line">{removeHTML_tags(content.description)}</p>}
                                          </div>
                                    </div>


                              </div>
                        </div>
                  </div>
            </>
      );
}

export default Shop;